module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-four-sub-one.934af3dc.jpg";